import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
var _excluded = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import contentKeys from 'actions/content/queryKeys';
import { formatContentUpdatePayload } from 'actions/assets/useUpdateMultipleAssets';
function useUpdateMultiplePlaylists(_ref) {
  var options = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  function updatePlaylists(_x) {
    return _updatePlaylists.apply(this, arguments);
  }
  function _updatePlaylists() {
    _updatePlaylists = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(playlists) {
      var updatePlaylistById, _updatePlaylistById, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _updatePlaylistById = function _updatePlaylistById3() {
              _updatePlaylistById = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(playlist) {
                var patchData, data;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      patchData = formatContentUpdatePayload({
                        content: playlist
                      });
                      _context.next = 3;
                      return api('patch', "/api/playlists/".concat(playlist.id), null, patchData);
                    case 3:
                      data = _context.sent;
                      return _context.abrupt("return", data);
                    case 5:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return _updatePlaylistById.apply(this, arguments);
            };
            updatePlaylistById = function _updatePlaylistById2(_x2) {
              return _updatePlaylistById.apply(this, arguments);
            };
            data = playlists.map(updatePlaylistById);
            return _context2.abrupt("return", Promise.all(data));
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _updatePlaylists.apply(this, arguments);
  }
  var _useMutation = useMutation(updatePlaylists, _objectSpread(_objectSpread({}, options), {}, {
      onSuccess: function onSuccess(data) {
        queryClient.invalidateQueries(contentKeys.allContent);
        setSuccessAlert({
          title: t('alert_playlist_updated_successfully', {
            count: data.length
          })
        });
      },
      onError: function onError(data) {
        setAlert({
          title: t('alert_playlist_not_updated', {
            count: data.length
          })
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded);
  return _objectSpread(_objectSpread({}, result), {}, {
    updateMultiplePlaylists: mutateAsync
  });
}
export default useUpdateMultiplePlaylists;